import { FC } from 'react';
import { useTranslation } from '@packages/utils';
import { useTheme } from 'styled-components';
import { Tooltip } from '@idaho-aeyc/ui-kit';
import { Col, Row } from 'components/Base/Grid';
import { Text } from 'components/Base/Typography';
import { EIconNames, Icon } from 'components/Base/Icon';
import { EEventPartType } from 'data/types/events.types';
import { EAttendanceStatus } from 'data/types/registrants.types';
import { TAttendanceColumnProps } from './AttendanceColumn.types';

const AttendanceColumn: FC<TAttendanceColumnProps> = ({ attendances }) => {
  const theme = useTheme();
  const { t } = useTranslation({
    keyPrefix: 'enums.event-part-type-short',
  });

  if (!attendances.length) {
    return null;
  }

  const isStandalone =
    attendances.length === 1 &&
    attendances[0].partType === EEventPartType.STANDALONE;

  return (
    <Row gutter={[0, 4]} justify={isStandalone ? 'center' : 'start'}>
      {attendances.map(({ partType, attendanceStatus }) => {
        const isAttended =
          attendanceStatus === EAttendanceStatus.ATTENDED ||
          attendanceStatus === EAttendanceStatus.E_LEARNING;
        const tooltipTitle = isAttended ? 'Attended' : 'Absent';
        const iconNode = (
          <Tooltip title={tooltipTitle}>
            <Icon
              icon={isAttended ? EIconNames.CHECK : EIconNames.CLOSE}
              size={16}
              color={
                isAttended ? theme.colorPrimaryDefault : theme.colorPinkActive
              }
            />
          </Tooltip>
        );

        if (isStandalone) {
          return (
            <Col key={partType} span={24} style={{ textAlign: 'center' }}>
              {iconNode}
            </Col>
          );
        }

        return (
          <Col key={partType} span={24}>
            <Text fontWeight={theme.fontWeightSemiBold}>
              {t(partType)}:{'  '}
            </Text>
            {iconNode}
          </Col>
        );
      })}
    </Row>
  );
};

export default AttendanceColumn;
